import { UserDto } from "@merchant_api/models/user-dto";

export class UsersState {
    loading = false;
    error = null;
    record: Array<UserDto> = [];
}
